import styled from "styled-components";
import { Link } from "react-router-dom";
// Constants
import { primaryColor, primaryColorHover } from "../config/constants";

const NavigationLink = styled(Link)`
  margin: ${({ margin }) => margin && margin};
  padding: ${({ padding }) => (padding ? padding : `16px`)};
  width: ${({ width }) => width && width};
  height: 38px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fff;
  border-radius: 5px;
  background-color: ${({ background }) => (background ? background : primaryColor)};
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
  }
  @media (max-width: 610px) {
    margin: ${({ margin610 }) => margin610 && margin610};
    width: ${({ width610 }) => width610 && width610};
  }
`;
const NavName = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #fff;
`;

const Button = ({ name, path, padding, width, width610, width910, margin, margin610, background }) => {
  return (
    <NavigationLink
      to={path}
      margin={margin}
      margin610={margin610}
      padding={padding}
      width={width}
      width610={width610}
      width910={width910}
      background={background}
    >
      <NavName>{name}</NavName>
    </NavigationLink>
  );
};

export default Button;
